import styled from 'styled-components';
import IconUtils from '../utils/icon-utils';

/*
  Caret/Left:   https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Component-Library?node-id=161%3A11
  Caret/Right:  https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Component-Library?node-id=161%3A12
  Caret/Up:     https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Component-Library?node-id=161%3A13
  Caret/Down:   https://www.figma.com/file/y90piHmWzPWasY4ZkcdXVs/Component-Library?node-id=161%3A14
 */
const Caret = ({
  className,
  color,
  down = true,
  filled,
  height = 16,
  left,
  right,
  theme = IconUtils.THEMES.default,
  up,
  width = 16,
}) => (
  <CaretFilledContainer className={className} color={color} filled={filled} height={height} theme={theme} width={width}>
    {_svg({ filled, width, height, left, right, up, down })}
  </CaretFilledContainer>
);

const _svg = ({ filled, width, height, left, right, up, down }) => {
  if (filled) {
    if (left) return <LeftFilledSVG width={width} height={height} />;
    if (right) return <RightFilledSVG width={width} height={height} />;
    if (up) return <UpFilledSVG width={width} height={height} />;
    return <DownFilledSVG width={width} height={height} />;
  }
  if (left) return <LeftSVG width={width} height={height} />;
  if (right) return <RightSVG width={width} height={height} />;
  if (up) return <UpSVG width={width} height={height} />;
  return <DownSVG width={width} height={height} />;
};

const LeftFilledSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.71458 7.57125L9.24275 5.45435C9.57601 5.25439 10 5.49445 10 5.8831V10.1169C10 10.5056 9.57601 10.7456 9.24275 10.5457L5.71458 8.42875C5.39091 8.23454 5.39091 7.76545 5.71458 7.57125Z" />
  </svg>
);

const RightFilledSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2854 8.42875C10.6091 8.23454 10.6091 7.76545 10.2854 7.57125L6.75725 5.45435C6.42399 5.25439 6 5.49445 6 5.8831V10.1169C6 10.5056 6.42399 10.7456 6.75725 10.5457L10.2854 8.42875Z" />
  </svg>
);

const UpFilledSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5457 9.24275C10.7456 9.57601 10.5056 10 10.1169 10H5.8831C5.49445 10 5.25439 9.57601 5.45435 9.24275L7.57125 5.71458C7.76546 5.39091 8.23455 5.39091 8.42875 5.71458L10.5457 9.24275Z" />
  </svg>
);

const DownFilledSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5457 6.75725C10.7456 6.42399 10.5056 6 10.1169 6H5.8831C5.49445 6 5.25439 6.42399 5.45435 6.75725L7.57125 10.2854C7.76546 10.6091 8.23455 10.6091 8.42875 10.2854L10.5457 6.75725Z" />
  </svg>
);

const LeftSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4L6 8L10 12" />
  </svg>
);

const RightSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4L10 8L6 12" />
  </svg>
);

const UpSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 10L8 6L12 10" />
  </svg>
);

const DownSVG = ({ width, height }) => (
  <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6L8 10L12 6" />
  </svg>
);

const CaretFilledContainer = styled.div`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  border-radius: 0.5px;

  > svg {
    & path {
      ${({ color, filled, theme }) => {
        const { fill, stroke } = IconUtils.getColorOrDefault(color, theme);
        if (filled) {
          return `fill: ${fill};`;
        }
        return `stroke: ${stroke};`;
      }}
    }
  }
`;

export default Caret;
